// Code generated by OpenAPI Generator (https://openapi-generator.tech), manual changes will be lost - read more on https://github.com/algolia/api-clients-automation. DO NOT EDIT.

import {
  createBrowserLocalStorageCache,
  createFallbackableCache,
  createMemoryCache,
  createNullLogger,
} from '@algolia/client-common';
import { createXhrRequester } from '@algolia/requester-browser-xhr';

import type { ClientOptions } from '@algolia/client-common';

import { apiClientVersion, createAbtestingV3Client } from '../src/abtestingV3Client';

import type { Region } from '../src/abtestingV3Client';
import { REGIONS } from '../src/abtestingV3Client';

export type { Region, RegionOptions } from '../src/abtestingV3Client';

export { apiClientVersion } from '../src/abtestingV3Client';

export * from '../model';

export function abtestingV3Client(
  appId: string,
  apiKey: string,
  region?: Region | undefined,
  options?: ClientOptions | undefined,
): AbtestingV3Client {
  if (!appId || typeof appId !== 'string') {
    throw new Error('`appId` is missing.');
  }

  if (!apiKey || typeof apiKey !== 'string') {
    throw new Error('`apiKey` is missing.');
  }

  if (region && (typeof region !== 'string' || !REGIONS.includes(region))) {
    throw new Error(`\`region\` must be one of the following: ${REGIONS.join(', ')}`);
  }

  return createAbtestingV3Client({
    appId,
    apiKey,
    region,
    timeouts: {
      connect: 1000,
      read: 2000,
      write: 30000,
    },
    logger: createNullLogger(),
    requester: createXhrRequester(),
    algoliaAgents: [{ segment: 'Browser' }],
    authMode: 'WithinQueryParameters',
    responsesCache: createMemoryCache(),
    requestsCache: createMemoryCache({ serializable: false }),
    hostsCache: createFallbackableCache({
      caches: [createBrowserLocalStorageCache({ key: `${apiClientVersion}-${appId}` }), createMemoryCache()],
    }),
    ...options,
  });
}

export type AbtestingV3Client = ReturnType<typeof createAbtestingV3Client>;
